import React__default from 'react';
import clsx from 'clsx';
import { OutlineButton } from '../../../buttons/index.js';
import { formatBytes } from '../../helper.js';
import './../../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../../util/Visible/Visible.js';
import Spacer from '../../../util/Spacer/Spacer.js';
import ProgressBarContainer from '../ProgressBar/ProgressBarContainer.js';
import cloudImage from './cloud-computing.png.js';
import { cssProcessingZone, cssProcessingZoneProgressBar, cssProcessing, cssProcessingTitle, cssProcessingUploadingTitle, cssProcessingInfo, cssProcessingPercentage, cssProcessingPercentageValue, cssProcessingButton } from './ProcessingZone.css.js';
import { cssCloudImage } from '../../index.css.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const ProcessingZoneComponent = ({ title, cancelBtnLabel = 'Cancel', progressConfig, areFilesUploading, totalFileSize, onCancel, setProgressConfig }) => (React__default.createElement("div", { className: `c-processing-zone ${cssProcessingZone}` },
    React__default.createElement(Visible, { when: !areFilesUploading },
        React__default.createElement(ProgressBarContainer, { className: `c-processing-zone__progress-bar ${cssProcessingZoneProgressBar}`, progressConfig: progressConfig, setProgress: setProgressConfig })),
    React__default.createElement("div", { className: `c-processing ${cssProcessing}` },
        React__default.createElement(Visible, { when: areFilesUploading },
            React__default.createElement("img", { "data-testid": 'upload-in-progress-image', className: `c-cloud-image ${cssCloudImage}`, src: cloudImage }),
            React__default.createElement(Spacer, { bottom: 20 })),
        React__default.createElement("div", { "data-testid": 'processing-title', className: clsx({
                [cssProcessingTitle]: !areFilesUploading,
                [cssProcessingUploadingTitle]: areFilesUploading
            }) }, title),
        React__default.createElement(Spacer, { top: 27 }),
        React__default.createElement(Visible, { when: areFilesUploading },
            React__default.createElement("div", { "data-testid": 'processing-info', className: cssProcessingInfo }, `( ${formatBytes(totalFileSize)} )`)),
        React__default.createElement(Visible, { when: !areFilesUploading },
            React__default.createElement("div", { className: cssProcessingPercentage },
                React__default.createElement("span", { className: cssProcessingPercentageValue }, progressConfig?.progress),
                React__default.createElement("span", null, "%")),
            React__default.createElement(Spacer, { bottom: 40 }),
            React__default.createElement(OutlineButton, { "data-testid": 'processing-button', onClick: onCancel, className: cssProcessingButton }, cancelBtnLabel)))));

export { ProcessingZoneComponent as default };
//# sourceMappingURL=ProcessingZoneComponent.js.map
